import "../../../../assets/presentation/components/controls/icon/icon-Bu5YZ2T6.css";
/* empty css     */
import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/presentation/components/controls/icon/icon.tsx
var IconVariation = /* @__PURE__ */ function(IconVariation) {
	IconVariation["FILLED"] = "filled";
	IconVariation["OUTLINED"] = "outlined";
	IconVariation["SYMBOLS_OUTLINED"] = "symbols-outlined";
	return IconVariation;
}({});
var IconColor = /* @__PURE__ */ function(IconColor) {
	IconColor["DEFAULT"] = "default";
	IconColor["WHITE"] = "white";
	IconColor["BLUE"] = "blue";
	IconColor["NEUTRAL"] = "neutral";
	IconColor["BLACK"] = "black";
	IconColor["DANGER"] = "danger";
	return IconColor;
}({});
var Icon = ({ className, icon, testId, variation = "filled", color = "default" }) => {
	const spanRef = useRef(null);
	const [isFontLoaded, setIsFontLoaded] = useState(false);
	useEffect(() => {
		if (!document.querySelector("link[href*=\"Material+Icons\"]")) {
			const link = document.createElement("link");
			link.href = "https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined&display=swap";
			link.rel = "stylesheet";
			document.head.appendChild(link);
		}
		const checkFontLoaded = () => {
			const fontFamily = variation === "outlined" ? "Material Icons Outlined" : "Material Icons";
			return document.fonts.check(`400 22px "${fontFamily}"`);
		};
		if (checkFontLoaded()) {
			setIsFontLoaded(true);
			return;
		}
		document.fonts.ready.then(() => {
			if (checkFontLoaded()) setIsFontLoaded(true);
			else setTimeout(() => {
				setIsFontLoaded(true);
			}, 100);
		});
	}, [variation]);
	if (!isFontLoaded) return null;
	return /* @__PURE__ */ jsx("span", {
		ref: spanRef,
		className: classNames(className, "icon", variation === "outlined" && "outlined", variation === "symbols-outlined" && "symbols-outlined", color !== "default" && `icon--${color}`, icon, "font-loaded"),
		"data-testid": testId
	});
};
//#endregion
export { Icon, IconColor, IconVariation };

//# sourceMappingURL=icon2.js.map